module.exports = __webpack_public_path__ + "media/images/discover/confirmation/confirmation-image-e66c337aa994659f748e6bf2cb282040.png";